import React from "react";
import { withBaseIcon } from "react-icons-kit";
import { arrowUnsorted } from "react-icons-kit/typicons/arrowUnsorted";
import { sortDesc } from "react-icons-kit/fa/sortDesc";
import { sortAsc } from "react-icons-kit/fa/sortAsc";
import { ic_navigate_next } from "react-icons-kit/md/ic_navigate_next";
import { ic_navigate_before } from "react-icons-kit/md/ic_navigate_before";
import { plusCircle } from "react-icons-kit/feather/plusCircle";
import { ic_delete } from "react-icons-kit/md/ic_delete";
import { iosPaw } from "react-icons-kit/ionicons/iosPaw";
import { ic_clear } from "react-icons-kit/md/ic_clear";
import { ic_search_off_outline } from "react-icons-kit/md/ic_search_off_outline";
import { warning } from "react-icons-kit/ikons/warning";

const IconContainer = withBaseIcon({ size: 20 });

export const getIconImage = (iconID?: string) => {
  const icons: { [key: string]: { alt: string; src: string } } = {
    0: { alt: "Bone", src: "/icons/0Bone.png" },
    1: { alt: "Butterfly", src: "/icons/1Butterfly.png" },
    2: { alt: "Cactus", src: "/icons/2Cactus.png" },
    3: { alt: "Fin", src: "/icons/3Fin.png" },
    4: { alt: "FootPrint", src: "/icons/4Footprint.png" },
    5: { alt: "Frog", src: "/icons/5Frog.png" },
    6: { alt: "Leaf", src: "/icons/6Leaf.png" },
    7: { alt: "Lizard", src: "/icons/7Lizard.png" },
    8: { alt: "Magnifying Glass", src: "/icons/8MagnifyingGlass.png" },
    9: { alt: "Mountain", src: "/icons/9Mountain.png" },
    10: { alt: "Palm Tree", src: "/icons/10PalmTree.png" },
    11: { alt: "Paw", src: "/icons/11Paw.png" },
    12: { alt: "Question Mark", src: "/icons/12QuestionMark.png" },
    13: { alt: "Snowflake", src: "/icons/13Snowflake.png" },
    15: { alt: "Wave", src: "/icons/15Wave.png" },
    16: { alt: "Wing", src: "/icons/16Wing.png" },
  };

  if (iconID && icons[iconID]) {
    // Return the corresponding icon based on the iconID
    const icon = icons[iconID];
    return <img alt={icon.alt} src={icon.src} className="h-5" />;
  }

  // If the iconID is invalid, return a fallback (e.g., a default icon or nothing)
  return null;
};

export const SortArrow = () => <IconContainer icon={arrowUnsorted} />;
export const Warning = () => <IconContainer icon={warning} />;
export const SortDesc = () => <IconContainer icon={sortDesc} />;
export const SortAsc = () => <IconContainer icon={sortAsc} />;
export const NextIcon = () => (
  <IconContainer icon={ic_navigate_next} className="text-slate-300" />
);
export const PrevIcon = () => (
  <IconContainer icon={ic_navigate_before} className="text-slate-300" />
);

export const AddIcon = () => (
  <IconContainer icon={plusCircle} className="text-slate-400" />
);
export const DeleteIcon = () => (
  <IconContainer icon={ic_delete} className="text-black" size="24" />
);

export const PawIcon = () => (
  <IconContainer icon={iosPaw} className="text-black" size="24" />
);

export const ClearIcon = () => (
  <IconContainer icon={ic_clear} className="text-black" size="24" />
);

export const ClearSearchIcon = () => (
  <IconContainer
    icon={ic_search_off_outline}
    className="text-black"
    size="24"
  />
);
